
        import * as React from "react";
        import BaseComponent from "src/engine/ui/BaseComponent";
        import Image from "./Image";
        import Manifest from "src/engine/Manifest";
        interface IUIIconFont {
            className?: string;
            defaultType?: string;
            type: string;
            url?: string;
        }
        class UIIconFont extends BaseComponent<IUIIconFont> {
            static manifest = {};
            static manifestInit = false;
            render() {
                const props = { ...this.props };
                if (props.url || UIIconFont.manifest[props.type]) {
                    return (
                        <Image
                            className="ui-icon"
                            style={{ height: "20px", display: "inline-block", backgroundSize: "contain" }}
                            uiItem={Manifest.ui("", "")}
                            src={props.url || UIIconFont.manifest[props.type]}
                        />
                    );
                }
                return null;
            }
        }
        export default UIIconFont;